import { VendorsTypes } from "@/enums/VendorsTypes";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { vendorsFileHeaders } from "@/utils/importHalper";
import * as firebase from "firebase/app";
import { trimStringFields } from '@/utils/stringFormat';

export default {
  name: "AddVendorDialog",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      loading: false,
      isManual: true,
      isEdit: false,
      csv: null,
      csvVendors: [],
      csvHeaders: vendorsFileHeaders,
      importedVendorsNumber: 0,
      updatedVendorsNumber: 0,
      vendor: {
        name: "",
        type: "",
        category: "",
        categoryId: "",
        phoneNumber: "",
        email: ""
      },
      filename: null,
      isError: false,
      isInfo: false,
      errorContent: "",
      infoContent: "",

      csvDowloadTemplateUrl: 'https://firebasestorage.googleapis.com/v0/b/reshub-test.appspot.com/o/csv-templates%2FVendors%20CSV%20template%20-%20Sheet2.csv?alt=media&token=44816ba0-7a74-436e-a4ee-3c31423eabd1'
    }
  },
  methods: {
    applyDefaultVendorType() {
      if (this.isEdit) return;

      if (this.vendorsTypes.length === 1) {
        this.vendor.type = this.vendorsTypes[0];
        return;
      }

      if (!this.vendorsTypes.includes(this.vendor.type)) {
        this.vendor.type = "";
      }
    },
    open(vendorToEdit) {
      this.$store.dispatch("getMaintenanceCategories");

      if (vendorToEdit) {
        this.vendor = { ...vendorToEdit }
        this.isEdit = true
      }
      this.dialog = true;
      this.isManual = true;
      this.applyDefaultVendorType();
    },
    async upsertVendor() {
      const form = this.$refs.addVendorForm as any;
      const validated = form.validate();
      if (!validated) return;

      this.loading = true

      try {
        if (this.isTypeMaintenance && this.vendor.categoryId) {
          const category = this.maintenanceCategories.find(x => x.id === this.vendor.categoryId);
          this.vendor.category = category?.name || null;
        } else {
          delete this.vendor.categoryId;
        }

        if (this.isEdit) {
          await this.$store.dispatch('updateVendor', this.vendor);
        } else {
          await this.$store.dispatch('addVendor', this.vendor);
        }
      } catch (error) {
        console.error('Error updating or adding vendor:', error);
      } finally {
        this.loading = false;
        this.close();
      }
    },
    async importVendors() {
      this.loading = true;
      const ids = [];
      const batchArray = [];
      batchArray.push(firebase.firestore().batch());
      let operationCounter = 0;
      let batchIndex = 0;
      this.importedVendorsNumber = 0
      this.updatedVendorsNumber = 0

      for (let i = 0; i < this.csvVendors.length; i++) {
        operationCounter++;
        const csvVendor = this.csvVendors[i]

        try {
          const vendorRef = firebase.firestore().collection('vendors').doc();

          const existingVendorSnap = await firebase.firestore().collection('vendors')
            .where('facilityId', '==', this.facility.id)
            .where('email', '==', csvVendor.email).get()

          const existingVendor: any = existingVendorSnap.size ? { id: existingVendorSnap.docs[0].id, ...existingVendorSnap.docs[0].data() } : null

          if (existingVendor) {
            const existingVendorRef = firebase.firestore().collection('vendors').doc(existingVendor.id)

            const updateData = {}
            let isUpdate = false

            if (csvVendor.name != existingVendor.name) {
              updateData['name'] = csvVendor.name
              isUpdate = true
            }
            if (csvVendor.type != existingVendor.type) {
              updateData['type'] = csvVendor.type
              isUpdate = true
            }
            if (csvVendor.category != existingVendor.category) {
              updateData['category'] = csvVendor.category;

              if(updateData['type'] === VendorsTypes.Maintenance) {
                const existingCategorySnap = await firebase.firestore().collection('maintenanceCategories')
                  .where('facilityId', '==', this.facility.id)
                  .where('name', '==', csvVendor.category).get();

                if(existingCategorySnap.docs.length > 0) {
                  updateData['categoryId'] = existingVendorSnap.docs[0].id
                } else {
                  const newCategory = { facilityId: this.facility.id, name: csvVendor.category };
                  trimStringFields(newCategory);
                  await firebase.firestore().collection('maintenanceCategories')
                    .add(newCategory)
                    .then((querySnapshot) => {
                      updateData['categoryId'] = querySnapshot.id;
                    })
                }
              }

              isUpdate = true
            }
            if (csvVendor.email != existingVendor.email) {
              updateData['email'] = csvVendor.email
              isUpdate = true
            }
            if (csvVendor.phoneNumber != existingVendor.phoneNumber) {
              updateData['phoneNumber'] = csvVendor.phoneNumber
              isUpdate = true
            }


            if (isUpdate === true) {
              trimStringFields(updateData);
              batchArray[batchIndex].update(existingVendorRef, updateData)
              console.log(`update vendor ${csvVendor.name}`, updateData)
              this.updatedVendorsNumber++;
            }
          }
          else {
            if(csvVendor.type === VendorsTypes.Maintenance) {
              const existingCategorySnap = await firebase.firestore().collection('maintenanceCategories')
                .where('facilityId', '==', this.facility.id)
                .where('name', '==', csvVendor.category).get();

              if(existingCategorySnap.docs.length > 0) {
                csvVendor.categoryId = existingCategorySnap.docs[0].id
              } else {
                const newCategory = { facilityId: this.facility.id, name: csvVendor.category };
                trimStringFields(newCategory);
                await firebase.firestore().collection('maintenanceCategories')
                  .add(newCategory)
                  .then((querySnapshot) => {
                    csvVendor.categoryId = querySnapshot.id;
                  })
              }
            }

            console.log('add vendor ', csvVendor)
            batchArray[batchIndex].set(vendorRef, csvVendor)
            this.importedVendorsNumber++;
          }

          if (operationCounter === 300) {
            console.log(`batchArray.push(${batchArray.length})`)
            batchArray.push(firebase.firestore().batch());
            batchIndex++;
            operationCounter = 0;
          }

          ids.push(vendorRef.id);
        } catch (error) {
          console.error('batch set error: ', error);
        }
      }

      try {
        for (let index = 0; index < batchArray.length; index++) {
          const batch = batchArray[index]
          if (batch && batch.Ed && batch.Ed.length) {
            console.log(`batch[${index}].commit(${batch.Ed.length})`)
          }
          await batch.commit()
        }
      } catch (error) {
        console.error('batch commit error: ', error)
        this.$toast.open({ message: 'Unhandled error. Unable to import vendors.', type: 'error' })
        this.loading = false;
        return;
      }

      let message = ''
      let type = 'success'

      if (this.importedVendorsNumber > 0) {
        message = `Imported ${this.importedVendorsNumber} vendor${this.importedVendorsNumber > 1 ? 's' : ''}. ${this.updatedVendorsNumber > 0 ? '</br>' : ''}`
      }

      if (this.updatedVendorsNumber > 0) {
        message += `Updated ${this.updatedVendorsNumber} vendor${this.updatedVendorsNumber > 1 ? 's' : ''}.`
      }

      if (!this.importedVendorsNumber && !this.updatedVendorsNumber) {
        type = 'info'
        message = 'The system is up to date. </br> No one vendors has been imported or updated.'
      }

      this.$toast.open({ message: message, type: type })

      if (this.importedVendorsNumber > 0 || this.updatedVendorsNumber > 0) {
        await this.$store.dispatch("getVendors");
        await this.$store.dispatch("getMaintenanceCategories");
      }
      this.close()

    },
    close() {
      this.dialog = false;
      this.isEdit = false
      this.filename = null;
      this.csvFileName = '';
      this.csv = null;
      this.csvData = null;
      this.loading = false;
      this.csvVendors = []
      this.vendor.name = null
      this.vendor.category = null
      this.vendor.categoryId = null
      this.vendor.type = null
      this.vendor.phoneNumber = null
      this.vendor.email = null
      this.$refs.addVendorForm.reset()
      this.clearError()
      this.clearInfo()
    },
    onLoadFile(e) {
      if (!e || !e.currentTarget || !this.$papa || !this.$papa.parse) return

      const file = e.currentTarget.files[0]

      this.filename = file.name
      
      this.$papa.parse(file, {
        header: true,
        complete: this.onComplete,
        skipEmptyLines: true
      })
    },
    async onComplete(results, file) {
      this.clearError()
      this.clearInfo()

      if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
        const message = this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.PleaseUploadaCSVFile'];
        this.setError(message);
        return false;
      }

      if (!this.isCsvColumnsValid(results)) {
        const message = `It looks like your file has missing columns. See our <a href='${this.csvDowloadTemplateUrl}' download='download'>downloadable template</a> to see how your file should be formatted.`;
        this.setError(message)
        return false;
      }

      if (!this.isCsvDataValid(results)) {
        const message = "Some of your columns have missing data. Please edit your file and try again.";
        this.setError(message)
        return false;
      }

      this.csvData = results.data;
      this.csvFileName = file.name
      await this.mapCsvDataToObjects(this.csvData)
      this.csv = results;
    },
    async mapCsvDataToObjects(csvData) {

      this.loading = true

      for (let i = 0; i < csvData.length; i++) {
        let vendorName = ''
        try {
          const raw = csvData[i]
          vendorName = this.getRawValues(raw).name
          const type = this.getRawValues(raw).type
          const category = this.getRawValues(raw).category
          const email = this.getRawValues(raw).email
          const phoneNumber = this.getRawValues(raw).phoneNumber

          const csvVendor = {
            name: vendorName,
            type: type,
            category: category,
            email: email.trim().toLowerCase(),
            phoneNumber: phoneNumber,
            isFromCsv: true,
            csvFileName: this.csvFileName,
            facilityId: this.facility.id,
            createdDateTime: firebase.firestore.Timestamp.fromDate(new Date()),
          }

          trimStringFields(csvVendor);

          if (!this.csvVendors.some(x => x.email === email)) {
            this.csvVendors.push(csvVendor)
          }

        } catch (error) {
          this.setError(`${vendorName} vendor has invalid data, this record will be ignored.`)
          throw new Error(`mapCsvDataToObjects() Unable to map residents csv record/s. filename: ${this.csvFileName}. Error merrage: ${error}`);
        }
      }

      this.loading = false
    },
    isManualChange(e) {
      if (e === true) {
        this.filename = null;
        this.csvFileName = '';
        this.csv = null;
        this.csvData = null;
        this.clearError()
        this.applyDefaultVendorType()
      } else if (e === false) {
        this.$refs.addVendorForm.reset()
        this.isManual = false
      }
      this.loading = false
    },
    isCsvDataValid(results) {
      const invalidRows = results.data.filter((raw) =>
        !this.getRawValues(raw).name
        || !this.getRawValues(raw).type
        || !this.getRawValues(raw).category
        || !this.getRawValues(raw).phoneNumber
        || !this.getRawValues(raw).email
      )

      if (invalidRows.length > 0) {
        console.log('invalidRows:', invalidRows)
      }

      return invalidRows.length == 0
    },
    isCsvColumnsValid(results) {
      const isHeadersValid = (results.meta.fields.filter(f =>
        f.includes(this.csvHeaders.name)
        || f.includes(this.csvHeaders.type)
        || f.includes(this.csvHeaders.category)
        || f.includes(this.csvHeaders.phoneNumber)
        || f.includes(this.csvHeaders.email)
      ).length === results.meta.fields.length)

      if (!isHeadersValid) return false

      return true
    },
    getRawValues(raw) {
      const data = {
        name: '',
        type: '',
        category: '',
        phoneNumber: '',
        email: ''
      }

      for (const key of Object.keys(raw)) {

        const value = raw[key] && typeof raw[key] === 'string' ? raw[key].trim() : raw[key]

        if (key.toLowerCase().includes(this.csvHeaders.name.toLowerCase())) {
          data.name = value
        } else if (key.toLowerCase() == this.csvHeaders.type.toLowerCase()) {
          data.type = value
        } else if (key.toLowerCase() == this.csvHeaders.category.toLowerCase()) {
          data.category = value
        } else if (key.toLowerCase() == this.csvHeaders.phoneNumber.toLowerCase()) {
          data.phoneNumber = value
        } else if (key.toLowerCase() == this.csvHeaders.email.toLowerCase()) {
          data.email = value
        }
      }

      return data
    },
    clearError() {
      this.isError = false;
      this.errorContent = "";
    },
    clearInfo() {
      this.isInfo = false;
      this.infoContent = "";
    },
    setError(message, concat) {
      if (concat === true) {
        this.errorContent += `<br> ${message}`;
      }
      else {
        this.errorContent = message;
      }
      this.isError = true;
      this.filename = null;
      this.csvFileName = '';
      this.csv = null;
      this.$refs.selectFileRef.focusout;
    },
    setInfo(message) {
      this.isInfo = true;
      this.infoContent = message;
    }
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    mailingLists() {
      return this.$store.state.facilityModule.facilityMailingLists;
    },
    vendorsTypes() {
      const types = [];

      if (this.facility?.maintenanceEnabled) {
        types.push(VendorsTypes.Maintenance);
      }

      if (this.facility?.featureConcierge) {
        types.push(VendorsTypes.Concierge);
      }

      return types;
    },
    isSingleVendorType() {
      return this.vendorsTypes.length === 1;
    },
    maintenanceCategories() {
      return this.$store.getters.maintenanceCategories;
    },
    isTypeMaintenance() {
      return this.vendor.type === VendorsTypes.Maintenance;
    }
  }
}